import React, {
  Dispatch,
  SetStateAction,
  useState,
  useEffect,
  useContext,
} from "react";
import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Label,
  Input,
  Table,
  Form,
} from "reactstrap";
import { AvForm } from "availity-reactstrap-validation";
import { ThemeContext } from "../../helpers/themeContext";
import {
  ADD_AUTOMATION,
  GET_ALL_USERS,
  GET_INBOXES,
  GET_ORGANISATIONS,
  GET_RESPONSE_KEYWORDS,
  GET_USERS,
} from "./query";
import SweetAlert from "react-bootstrap-sweetalert";
import client from "../../apollo";
import { toNumber } from "lodash";
import AddEstateAgentAutomation from "./AddEstateAgentAutomation";
import AddEstateAgentCTAAutomation from "./AddEstateAgentCTAAutomation";
import {
  KEYWORD_ANYWHERE,
  KEYWORD_ONLY,
  KEYWORD_WORD,
  PHRASE,
  PHRASEEXACT,
} from "./helper";
import { useMutation } from "@apollo/client";
import { setResellerId } from "src/apollo/link";
interface IProps {
  modal: boolean;
  setModal: Dispatch<SetStateAction<boolean>>;
  refresh: any;
}

const AddBotAutoamtion = (props: IProps) => {
  const toggle = () => {
    props.setModal(!props.modal);
  };

  const [organisations, setOrganisations] = useState([]);
  const [selectedOrg, setSelectedOrg] = useState<number>(-1);

  interface APIAccount {
    APIAccountId: number;
    Name: string;
  }
  const [APIAccounts, setAPIAccounts] = useState<APIAccount[]>([]);
  const [selectedAPIAccount, setSelectedAPIAccount] = useState<number>(-1);

  const [selectedAutomation, setSelectedAutoMation] = useState(0);

  const [loading, setLoading] = useState(false);
  const [success_dlg, setsuccess_dlg] = useState(false);
  const [failure_dlg, setfailure_dlg] = useState(false);
  const Theme = useContext(ThemeContext);
  const [dynamic_description, setdynamic_description] = useState("");

  const [keyword, setKeyword] = useState("");
  const [reply, setReply] = useState("");

  const [responseTypeOptions, setResponseTypeOptions] = useState([
    {
      label: "Reply",
      value: 1,
    },
    {
      label: "Assign",
      value: 2,
    },
    {
      label: "Route",
      value: 3,
    },
  ]);
  const [responseType, setResponseType] = useState<any>(responseTypeOptions[0]);
  const [routeType, setRouteType] = useState<any>();
  const [routeTypeOptions, setRouteTypeOptions] = useState<any[]>();

  const [matchTypeOptions, setMatchTypeOptions] = useState([
    {
      value: KEYWORD_ONLY,
      label: "Keyword Only",
    },
    {
      value: KEYWORD_ANYWHERE,
      label: "Keyword Anywhere",
    },
    {
      value: KEYWORD_WORD,
      label: "Keyword as word",
    },
    {
      value: PHRASE,
      label: "Phrase",
    },
    {
      value: PHRASEEXACT,
      label: "Exact Phrase",
    },
  ]);
  const [matchType, setMatchType] = useState<any>(matchTypeOptions[0]);

  const [featureOptions, setFeatureOptions] = useState([
    {
      label: "None",
      value: 0,
    },
    {
      label: "Quick Reply",
      value: 1,
    },
    {
      label: "List",
      value: 2,
    },
  ]);
  const [featureType, setFeatureType] = useState<any>(0);

  const [automationEnabledOptions, setAutomationEnabledOptions] = useState([
    { value: 0, label: "No" },
    { value: 1, label: "Yes" },
  ]);
  const [automationEnabled, setAutomationEnabled] = useState(0);

  const [automationRepliesOptions, setAutomationRepliesOptions] = useState([
    { value: 0, label: "No" },
    { value: 1, label: "Yes" },
  ]);
  const [automationRepliesEnabled, setAutomationRepliesEnabled] = useState(0);

  const [assignee, setAssignee] = useState<any>(null);
  const [assigneeOptions, setAssigneeOptions] = useState<any[]>();

  const [quickReplyOptions, setQuickReplyOptions] = useState([
    { value: 1, label: "Button 1 Text", textValue: "" },
    { value: 2, label: "Button 2 Text", textValue: "" },
    { value: 3, label: "Button 3 Text", textValue: "" },
  ]);

  const [listOptions, setListOptions] = useState([
    { value: 1, label: "List Item 1", textValue: "" },
    { value: 2, label: "List Item 2", textValue: "" },
    { value: 3, label: "List Item 3", textValue: "" },
    { value: 4, label: "List Item 4", textValue: "" },
    { value: 5, label: "List Item 5", textValue: "" },
    { value: 6, label: "List Item 6", textValue: "" },
    { value: 7, label: "List Item 7", textValue: "" },
    { value: 8, label: "List Item 8", textValue: "" },
    { value: 9, label: "List Item 9", textValue: "" },
    { value: 10, label: "List Item 10", textValue: "" },
  ]);

  const [addAutomation, { loading: addLoading, data: addData }] =
    useMutation(ADD_AUTOMATION);

  useEffect(() => {
    loadOrgs();
  }, []);

  useEffect(() => {
    loadInboxes();
  }, [selectedAPIAccount]);

  const loadInboxes = async () => {
    const response = await client.query({
      query: GET_INBOXES,
      variables: { apiAccountId: selectedAPIAccount },
    });
    const options:
      | React.SetStateAction<string>
      | {
          label: string;
          value: { inbox: { name: any; id: any }; folderId: any };
        }[] = [];
    response.data.msgbox_Inbox.forEach(
      (inbox: {
        APIAccount: { Name: any; APIAccountId: any };
        Folders: any[];
        Name: string;
        InboxId: any;
      }) => {
        if (inbox.APIAccount.APIAccountId === selectedAPIAccount) {
          inbox.Folders.forEach(folder => {
            options.push({
              label: inbox.Name + " " + `(${folder.Name})`,
              value: {
                inbox: {
                  name: inbox.Name,
                  id: inbox.InboxId,
                },
                folderId: folder.FolderId,
              },
            });
          });
        }
      }
    );
    setRouteType(options[0]);
    setRouteTypeOptions(options);
  };

  useEffect(() => {
    setSelectedAPIAccount(-1);
    const fullOrg: any = organisations.filter(
      (order: any, key: number) => order["OrganisationId"] == selectedOrg
    );
    if (fullOrg.length === 0) return;
    setAPIAccounts(fullOrg[0].APIAccounts);
    const apiId = fullOrg[0].APIAccounts[0]?.APIAccountId;
    setSelectedAPIAccount(apiId);
  }, [selectedOrg]);

  const loadOrgs = async () => {
    const orgs = await client.query({
      query: GET_ORGANISATIONS,
    });
    const orgData = orgs?.data?.msgbox_Organisation || [];
    const orgId = orgData[0]["OrganisationId"];
    setOrganisations(orgData);
    setSelectedOrg(orgId);
    const apiId = orgData[0].APIAccounts[0]?.APIAccountId;
    setSelectedAPIAccount(apiId);
  };

  const handleOrgSelect = async (target: number) => {
    setSelectedOrg(target);
  };

  const handleAPIAccountSelect = async (target: number) => {
    setSelectedAPIAccount(target);
  };

  const handleResponseTypeSelect = async (target: number) => {
    setResponseType(target);
  };

  const handleRouteTypeSelect = async (target: any) => {
    const parsedValue = JSON.parse(target);
    setRouteType(parsedValue);
  };

  const handleMatchTypeSelect = async (target: any) => {
    setMatchType(target);
  };

  const handleFeatureTypeSelect = async (target: number) => {
    setFeatureType(target);
  };

  const handleAutomationSelect = async (target: number) => {
    setSelectedAutoMation(target);
  };

  useEffect(() => {
    if (selectedAPIAccount) fetchUsers();
  }, [selectedAPIAccount]);

  const fetchUsers = async () => {
    const orgUsers = await client.query({
      query: GET_USERS,
      fetchPolicy: "no-cache",
      variables: { orgId: selectedOrg },
    });
    const users = await client.query({
      query: GET_ALL_USERS,
      fetchPolicy: "no-cache",
    });

    const options = [];
    orgUsers?.data?.msgbox_Organisation[0]?.Departments?.filter(
      (d: { DepartmentInboxes: any[] }) => {
        if (d.DepartmentInboxes.length == 0) return true;
        let arr = d.DepartmentInboxes.filter((i: { InboxId: number }) => {
          return i.InboxId == selectedAPIAccount;
        });
        return arr.length > 0 ? true : false;
      }
    ).forEach(
      (department: {
        UserDepartments: any[];
        Name: any;
        DepartmentId: any;
      }) => {
        if (department.UserDepartments.length > 0) {
          // Add the users to the dropdown
          const group = {
            label: department.Name,
            options: department.UserDepartments.map(user => ({
              label: user.User.FirstName + " " + user.User.LastName,
              value: {
                type: "user",
                value: user.User.UserId,
              },
            })),
          };
          // Add the department
          group.options.push({
            label: `Assign to team (${department.Name})`,
            value: {
              type: "department",
              value: department.DepartmentId,
            },
          });
          options.push(group);
        }
      }
    );
    const usersNotInATeam = users.data.msgbox_User
      .filter(
        (user: { UserDepartments: string | any[] }) =>
          user.UserDepartments.length < 1
      )
      .map((user: { UserId: any; FirstName: any; LastName: any }) => ({
        value: { type: "user", value: user.UserId },
        label: `${user.FirstName} ${user.LastName}`,
      }));
    options.push({
      label: "Users not in a team",
      options: usersNotInATeam,
    });

    setAssignee(options[0].options[0] || null);
    setAssigneeOptions(options);
  };

  const clearModal = () => {
    setSelectedOrg(organisations[0]["OrganisationId"]);
    setSelectedAPIAccount(-1);
    setKeyword("");
    setReply("");
    setResponseType(responseTypeOptions[0]);
    setAssignee(null);
    setRouteType(routeTypeOptions?.[0]);
    setMatchType(matchTypeOptions[0]);
    setFeatureType(0);
    setQuickReplyOptions([
      { value: 1, label: "Button 1 Text", textValue: "" },
      { value: 2, label: "Button 2 Text", textValue: "" },
      { value: 3, label: "Button 3 Text", textValue: "" },
    ]);
    setListOptions([
      { value: 1, label: "List Item 1", textValue: "" },
      { value: 2, label: "List Item 2", textValue: "" },
      { value: 3, label: "List Item 3", textValue: "" },
      { value: 4, label: "List Item 4", textValue: "" },
      { value: 5, label: "List Item 5", textValue: "" },
      { value: 6, label: "List Item 6", textValue: "" },
      { value: 7, label: "List Item 7", textValue: "" },
      { value: 8, label: "List Item 8", textValue: "" },
      { value: 9, label: "List Item 9", textValue: "" },
      { value: 10, label: "List Item 10", textValue: "" },
    ]);
    setAutomationEnabled(0);
    setAutomationRepliesEnabled(0);
  };
  useEffect(() => {
    console.log(matchType, `< match type`);
  }, [matchType]);

  const handleSubmit = async () => {
    setLoading(true);
    // console.log(`< VALUES to submit:`);
    // console.log(selectedOrg, `< Org `);
    // console.log(selectedAPIAccount, `< API Account `);
    // console.log(keyword, `< keyword`);
    // console.log(reply, `< reply`);
    // console.log(responseType, `< response type`);
    // console.log(assignee, `< assignee`);
    // console.log(routeType, `< route type`);
    // console.log(matchType, `< match type`);
    // console.log(featureType, `< feature`);
    // console.log(quickReplyOptions, `< quick reply values`);
    // console.log(listOptions, `< list values`);
    // console.log(automationEnabled, `< automation enabled`);
    // console.log(automationRepliesEnabled, `< automation replies enabled`);

    let ReplyMetaData = null;
    let ListMetaData = null;

    //handle quick reply case
    if (featureType === 1) {
      let temp = [];
      if (quickReplyOptions[0].textValue !== "") {
        temp.push({
          postbackText: "dev-defined-postback1",
          type: "text",
          title: quickReplyOptions[0].textValue,
        });
      }
      if (quickReplyOptions[1].textValue !== "") {
        temp.push({
          postbackText: "dev-defined-postback2",
          type: "text",
          title: quickReplyOptions[1].textValue,
        });
      }
      if (quickReplyOptions[2].textValue !== "") {
        temp.push({
          postbackText: "dev-defined-postback3",
          type: "text",
          title: quickReplyOptions[2].textValue,
        });
      }
      if (temp.length > 0) {
        ReplyMetaData = JSON.stringify(temp);
      }
    }
    //handle  list case
    if (featureType === 2) {
      let temp = [];
      if (listOptions[0].textValue !== "") {
        temp.push({
          postbackText: `${listOptions[0].textValue} postback payload`,
          type: "text",
          title: listOptions[0].textValue,
        });
      }
      if (listOptions[1].textValue !== "") {
        temp.push({
          postbackText: `${listOptions[1].textValue} postback payload`,
          type: "text",
          title: listOptions[1].textValue,
        });
      }
      if (listOptions[2].textValue !== "") {
        temp.push({
          postbackText: `${listOptions[2].textValue} postback payload`,
          type: "text",
          title: listOptions[2].textValue,
        });
      }
      if (listOptions[3].textValue !== "") {
        temp.push({
          postbackText: `${listOptions[3].textValue} postback payload`,
          type: "text",
          title: listOptions[3].textValue,
        });
      }
      if (listOptions[4].textValue !== "") {
        temp.push({
          postbackText: `${listOptions[4].textValue} postback payload`,
          type: "text",
          title: listOptions[4].textValue,
        });
      }
      if (listOptions[5].textValue !== "") {
        temp.push({
          postbackText: `${listOptions[5].textValue} postback payload`,
          type: "text",
          title: listOptions[5].textValue,
        });
      }
      if (listOptions[6].textValue !== "") {
        temp.push({
          postbackText: `${listOptions[6].textValue} postback payload`,
          type: "text",
          title: listOptions[6].textValue,
        });
      }
      if (listOptions[7].textValue !== "") {
        temp.push({
          postbackText: `${listOptions[7].textValue} postback payload`,
          type: "text",
          title: listOptions[7].textValue,
        });
      }
      if (listOptions[8].textValue !== "") {
        temp.push({
          postbackText: `${listOptions[8].textValue} postback payload`,
          type: "text",
          title: listOptions[8].textValue,
        });
      }
      if (listOptions[9].textValue !== "") {
        temp.push({
          postbackText: `${listOptions[9].textValue} postback payload`,
          type: "text",
          title: listOptions[9].textValue,
        });
      }
      if (temp.length > 0) {
        ListMetaData = JSON.stringify([
          { title: "Select An Option", options: temp },
        ]);
      }
    }

    // HERE is where you would call await addAutomation

    await addAutomation({
      variables: {
        orgId: selectedOrg,
        keyword: keyword?.trim(),
        reply: reply,
        assignTo:
          responseType === 2 && assignee.type === "user"
            ? assignee.value
            : null,
        routeTo: responseType === 3 ? routeType.folderId : null,
        account: selectedAPIAccount,
        assignToDepartment: assignee
          ? assignee.type === "department"
            ? assignee.value
            : null
          : null,
        matchType: matchType.value ? matchType.value : matchType,
        isEnabled: automationEnabled === 1 ? true : false,
        ListMetaData,
        ReplyMetaData,
      },
    });
    //NEXT...

    if (automationRepliesEnabled === 1) {
      // build list of account IDs
      const accountsArray = APIAccounts.map(
        (item: { APIAccountId: string | number }) => item.APIAccountId
      );

      // query all existing replies
      const allReplies = await client.query<{
        msgbox_BotResponse: {
          Keyword: string;
          APIAccount?: { APIAccountId: string | number };
        }[];
      }>({
        query: GET_RESPONSE_KEYWORDS,
        variables: { apiAccounts: accountsArray },
      });

      // build lookup for existing replies
      const replyLookup: Record<string, boolean> = {};
      for (const replyItem of allReplies.data.msgbox_BotResponse) {
        if (replyItem.APIAccount?.APIAccountId) {
          const key = `${replyItem.Keyword}-${replyItem.APIAccount.APIAccountId}`;
          replyLookup[key] = true;
        }
      }

      // handle ListMetaData replies
      if (ListMetaData) {
        const options = JSON.parse(ListMetaData)[0].options as {
          title: string;
        }[];
        for (const item of options) {
          console.log(item, `< in list metadata clause, item in line 579`);
          console.log(assignee, `< assignee`);
          console.log(routeType, `< routetype`);
          const key = `${item.title}-${selectedAPIAccount}`;
          if (!replyLookup[key]) {
            await addAutomation({
              variables: {
                orgId: selectedOrg,
                keyword: item.title,
                reply: `${item.title} Automated Reply`,
                assignTo:
                  responseType === 2 && assignee.type === "user"
                    ? assignee
                    : null,
                routeTo: responseType === 3 ? routeType.folderId : null,
                account: selectedAPIAccount,
                assignToDepartment:
                  assignee && assignee?.type === "department"
                    ? assignee?.value
                    : null,
                matchType:
                  item.title.split(" ").length > 1 ? "Phrase" : "KeywordOnly",
                isEnabled: true,
                ListMetaData: null,
                ReplyMetaData: null,
              },
            });
          }
        }
      }

      // handle Quick Reply replies
      if (ReplyMetaData) {
        const options = JSON.parse(ReplyMetaData) as { title: string }[];
        for (const item of options) {
          console.log(item, `in replymetadata clause, < item in line 579`);
          console.log(assignee, `< assignee`);
          console.log(routeType, `< routetype`);
          const key = `${item.title}-${selectedAPIAccount}`;
          if (!replyLookup[key]) {
            await addAutomation({
              variables: {
                orgId: selectedOrg,
                keyword: item.title,
                reply: `${item.title} Automated Reply`,
                assignTo:
                  responseType === 2 && assignee.type === "user"
                    ? assignee.value
                    : null,

                routeTo: responseType === 3 ? routeType.folderId : null,
                account: selectedAPIAccount,
                assignToDepartment:
                  assignee && assignee?.type === "department"
                    ? assignee.value
                    : null,
                matchType:
                  item.title.split(" ").length > 1 ? "Phrase" : "KeywordOnly",
                isEnabled: true,
                ListMetaData: null,
                ReplyMetaData: null,
              },
            });
          }
        }
      }
    }

    setLoading(false);
    clearModal();
    props.setModal(false);
    setdynamic_description("Bot response created successfully");
    setsuccess_dlg(true);
  };

  return (
    <React.Fragment>
      {success_dlg ? (
        <SweetAlert
          success
          title={Theme.name}
          onConfirm={() => {
            setsuccess_dlg(false);
          }}
        >
          {dynamic_description}
        </SweetAlert>
      ) : null}
      {failure_dlg ? (
        <SweetAlert
          error
          title={Theme.name}
          onConfirm={() => {
            setfailure_dlg(false);
          }}
        >
          {dynamic_description}
        </SweetAlert>
      ) : null}
      <Modal isOpen={props.modal} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle} tag="h4">
          Add New Bot Automation
        </ModalHeader>
        <ModalBody className="modelStyle">
          <AvForm
            onValidSubmit={() => {
              handleSubmit();
            }}
          >
            <Row form className="d-flex flex-row mb-3">
              <Col>
                <FormGroup className="mb-3">
                  <Label>Select an Organisation</Label>
                  <Input
                    className="avInput"
                    id="selectOrg"
                    name="selectOrg"
                    type="select"
                    value={selectedOrg}
                    onChange={(e: React.FormEvent<HTMLInputElement>) => {
                      handleOrgSelect(toNumber(e.currentTarget.value));
                    }}
                  >
                    {Array.isArray(organisations)
                      ? organisations.map((order: any, key: number) => (
                          <option key={key} value={order["OrganisationId"]}>
                            {order["Name"]}
                          </option>
                        ))
                      : null}
                  </Input>
                </FormGroup>

                <FormGroup className="mb-3">
                  <Label>Select an API Account</Label>
                  <Input
                    className="avInput"
                    id="selectAPIAccount"
                    name="selectAPIAccount"
                    type="select"
                    value={selectedAPIAccount}
                    onChange={(e: React.FormEvent<HTMLInputElement>) => {
                      handleAPIAccountSelect(toNumber(e.currentTarget.value));
                    }}
                  >
                    {Array.isArray(APIAccounts)
                      ? APIAccounts.map((order: any, key: number) => (
                          <option key={key} value={order["APIAccountId"]}>
                            {order["Name"]}
                          </option>
                        ))
                      : null}
                  </Input>
                </FormGroup>

                <FormGroup className="mb-3">
                  <Label>Response Type*</Label>
                  <Input
                    className="avInput"
                    id="selectResponseType"
                    name="selectResponseType"
                    type="select"
                    value={responseType}
                    onChange={(e: React.FormEvent<HTMLInputElement>) => {
                      handleResponseTypeSelect(toNumber(e.currentTarget.value));
                    }}
                  >
                    {Array.isArray(responseTypeOptions)
                      ? responseTypeOptions.map((order: any, key: number) => (
                          <option key={key} value={order.value}>
                            {order.label}
                          </option>
                        ))
                      : null}
                  </Input>
                </FormGroup>

                {responseType === 2 && (
                  <FormGroup className="mb-3">
                    <Label>Assignee*</Label>
                    <Input
                      className="avInput"
                      id="selectAssignee"
                      name="selectAssignee"
                      type="select"
                      value={JSON.stringify(assignee)} // must be string if using objects
                      onChange={(e: React.FormEvent<HTMLInputElement>) => {
                        try {
                          const parsedValue = JSON.parse(e.currentTarget.value);
                          setAssignee(parsedValue);
                        } catch (err) {
                          console.error("Invalid JSON:", err);
                        }
                      }}
                    >
                      {Array.isArray(assigneeOptions)
                        ? assigneeOptions.map((group: any, key: number) => (
                            <React.Fragment key={key}>
                              <option disabled style={{ fontSize: 18 }}>
                                {group.label}
                              </option>
                              {group.options.map(
                                (teamOption: any, idx: number) => (
                                  <option
                                    key={idx}
                                    value={JSON.stringify(teamOption.value)} // stringify the object
                                  >
                                    {teamOption.label}
                                  </option>
                                )
                              )}
                            </React.Fragment>
                          ))
                        : null}
                    </Input>
                  </FormGroup>
                )}

                {responseType === 3 && (
                  <FormGroup className="mb-3">
                    <Label>Route to*</Label>
                    <Input
                      className="avInput"
                      id="selectRouteTo"
                      name="selectRouteTo"
                      type="select"
                      value={JSON.stringify(routeType)}
                      onChange={(e: React.FormEvent<HTMLInputElement>) => {
                        handleRouteTypeSelect(e.currentTarget.value);
                      }}
                    >
                      {Array.isArray(routeTypeOptions)
                        ? routeTypeOptions.map((order: any, key: number) => (
                            <option
                              key={key}
                              value={JSON.stringify(order.value)}
                            >
                              {order.label}
                            </option>
                          ))
                        : null}
                    </Input>
                  </FormGroup>
                )}

                <FormGroup className="mb-3">
                  <Label>Match Type*</Label>
                  <Input
                    className="avInput"
                    id="selectMatchType"
                    name="selectMatchType"
                    type="select"
                    value={matchType}
                    onChange={(e: React.FormEvent<HTMLInputElement>) => {
                      handleMatchTypeSelect(e.currentTarget.value);
                    }}
                  >
                    {Array.isArray(matchTypeOptions)
                      ? matchTypeOptions.map((order: any, key: number) => (
                          <option key={key} value={order.value}>
                            {order.label}
                          </option>
                        ))
                      : null}
                  </Input>
                </FormGroup>

                <FormGroup className="mb-3">
                  <Label>Feature*</Label>
                  <Input
                    className="avInput"
                    id="selectFeature"
                    name="selectFeature"
                    type="select"
                    value={featureType}
                    onChange={(e: React.FormEvent<HTMLInputElement>) => {
                      handleFeatureTypeSelect(toNumber(e.currentTarget.value));
                    }}
                  >
                    {Array.isArray(featureOptions)
                      ? featureOptions.map((order: any, key: number) => (
                          <option key={key} value={order.value}>
                            {order.label}
                          </option>
                        ))
                      : null}
                  </Input>
                </FormGroup>
              </Col>

              <div
                style={{
                  width: 20,
                }}
              ></div>

              <Col>
                <FormGroup className="mb-3">
                  <Label>Keyword*</Label>
                  <Input
                    className="textInput"
                    value={keyword}
                    onChange={(e: React.FormEvent<HTMLInputElement>) => {
                      setKeyword(e.currentTarget.value);
                    }}
                  ></Input>
                </FormGroup>

                <FormGroup className="mb-3">
                  <Label>Reply *</Label>
                  <Input
                    className="textInput"
                    id="selectReply"
                    name="selectReply"
                    type="textarea"
                    style={{ height: 206 }}
                    value={reply}
                    onChange={(e: React.FormEvent<HTMLInputElement>) => {
                      setReply(e.currentTarget.value);
                    }}
                  ></Input>
                </FormGroup>

                <FormGroup className="mb-3">
                  <Label>Automation Enabled</Label>
                  <Input
                    className="avInput"
                    id="automationEnabled"
                    name="automationEnabled"
                    type="select"
                    value={automationEnabled}
                    onChange={(e: React.FormEvent<HTMLInputElement>) => {
                      setAutomationEnabled(toNumber(e.currentTarget.value));
                    }}
                  >
                    {Array.isArray(APIAccounts)
                      ? automationEnabledOptions.map(
                          (order: any, key: number) => (
                            <option key={key} value={order.value}>
                              {order.label}
                            </option>
                          )
                        )
                      : null}
                  </Input>
                </FormGroup>

                <FormGroup className="mb-3">
                  <Label>Automation Replies Enabled</Label>
                  <Input
                    className="avInput"
                    id="automationRepliesEnabled"
                    name="automationRepliesEnabled"
                    type="select"
                    value={automationRepliesEnabled}
                    onChange={(e: React.FormEvent<HTMLInputElement>) => {
                      setAutomationRepliesEnabled(
                        toNumber(e.currentTarget.value)
                      );
                    }}
                  >
                    {Array.isArray(APIAccounts)
                      ? automationRepliesOptions.map(
                          (order: any, key: number) => (
                            <option key={key} value={order.value}>
                              {order.label}
                            </option>
                          )
                        )
                      : null}
                  </Input>
                </FormGroup>
              </Col>

              {featureType !== 0 && (
                <>
                  <div
                    style={{
                      width: 20,
                    }}
                  ></div>

                  {featureType === 1 && (
                    <Col>
                      {/* 3 button text boxes - 1,2, ns 3 
                        1 COL       */}

                      {quickReplyOptions.map((button, index) => {
                        return (
                          <FormGroup className="mb-3" key={button.value}>
                            <Label>{button.label}</Label>

                            <Input
                              className="textInput"
                              id={`${button.label}`}
                              name={`${button.label}`}
                              type="textarea"
                              //style={{ height: 206 }}
                              value={button.textValue}
                              onChange={(
                                e: React.FormEvent<HTMLInputElement>
                              ) => {
                                const newValue = e.currentTarget.value;
                                setQuickReplyOptions(prev =>
                                  prev.map((b, i) =>
                                    i === index
                                      ? { ...b, textValue: newValue }
                                      : b
                                  )
                                );
                              }}
                            ></Input>
                          </FormGroup>
                        );
                      })}
                    </Col>
                  )}
                  {featureType === 2 && (
                    <>
                      <Col>
                        {/* 10 List item text boxes - list item 1, 2... 10 
                        2 COLS - 5 each
                        */}
                        {listOptions.map((listOption, index) => {
                          if (listOption.value > 5) return null;
                          else {
                            return (
                              <FormGroup
                                className="mb-3"
                                key={listOption.value}
                              >
                                <Label>{listOption.label}</Label>
                                <Input
                                  className="textInput"
                                  id={`${listOption.label}`}
                                  name={`${listOption.label}`}
                                  type="textarea"
                                  //style={{ height: 206 }}
                                  value={listOption.textValue}
                                  onChange={(
                                    e: React.FormEvent<HTMLInputElement>
                                  ) => {
                                    const newValue = e.currentTarget.value;
                                    setListOptions(prev =>
                                      prev.map((b, i) =>
                                        i === index
                                          ? { ...b, textValue: newValue }
                                          : b
                                      )
                                    );
                                  }}
                                ></Input>
                              </FormGroup>
                            );
                          }
                        })}
                      </Col>
                      <div
                        style={{
                          width: 20,
                        }}
                      ></div>
                      <Col>
                        {listOptions.map((listOption, idx) => {
                          if (listOption.value <= 5) return null;
                          else {
                            return (
                              <FormGroup
                                className="mb-3"
                                key={listOption.value}
                              >
                                <Label>{listOption.label}</Label>
                                <Input
                                  className="textInput"
                                  id={`${listOption.label}`}
                                  name={`${listOption.label}`}
                                  type="textarea"
                                  //style={{ height: 206 }}
                                  value={listOption.textValue}
                                  onChange={(
                                    e: React.FormEvent<HTMLInputElement>
                                  ) => {
                                    const newValue = e.currentTarget.value;
                                    setListOptions(prev =>
                                      prev.map((b, i) =>
                                        i === idx
                                          ? { ...b, textValue: newValue }
                                          : b
                                      )
                                    );
                                  }}
                                ></Input>
                              </FormGroup>
                            );
                          }
                        })}
                      </Col>
                    </>
                  )}
                </>
              )}
            </Row>
            <Row>
              <Col>
                {!loading ? (
                  <div className="text-end">
                    <button
                      type="button"
                      className="btn btn-light w-sm"
                      onClick={() => props.setModal(false)}
                    >
                      Close
                    </button>
                    <button type="submit" className="btn btn-success save-user">
                      Add
                    </button>
                  </div>
                ) : (
                  <div className="text-end">
                    <button type="button" className="btn btn-light w-sm">
                      Loading
                    </button>
                  </div>
                )}
              </Col>
            </Row>
          </AvForm>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default AddBotAutoamtion;
